import { render, staticRenderFns } from "./PriorAuthorizationCreate.vue?vue&type=template&id=484dcd3c&scoped=true"
import script from "./PriorAuthorizationCreate.vue?vue&type=script&lang=ts"
export * from "./PriorAuthorizationCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484dcd3c",
  null
  
)

export default component.exports